/**
 * - Description -
 * StateService contains all the methods that allows the webapp to make and handle alerts.
 *
 * - Usage -
 * Using StateService
 *
 * import StateService from '@/helpers/AlertService.js';
 */
import store from "@/store";

export default {
    name: 'StateService',
    resetUserInfoAndSettings: resetUserInfoAndSettings,
    resetAllVolatileData: resetAllVolatileData
}


function resetUserInfoAndSettings() {
    console.debug("STATE.SERVICE - Reset user states.");
    store.dispatch("AppState/resetState");
    store.dispatch("UserState/resetState");
}

function resetAllVolatileData() {
    console.debug("STATE.SERVICE - Reset All states.");
    store.dispatch("ChatbotState/resetState");
    store.dispatch("FileInputState/resetState");
}
